import React, { useRef, useState, useEffect } from "react";
import profile from "../Assets/img/undraw_profile.svg";
import styles from "../Assets/student/studentstyle.module.css";
import logo from "../Assets/img/logo.png";
import logo2 from "../Assets/img/logo-small.png";
import MessageIcon from "@mui/icons-material/Message";
import { Link, useLocation } from "react-router-dom";
import Api from "./Api";
import { useNavigate } from "react-router-dom";
import ImpersonationBanner from "./ImpersonationBanner";

const Profile = ({ children }) => {
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth > 767);

  const [isDownloadsOpen, setIsDownloadsOpen] = useState(false);
  const [isResultsOpen, setIsResultsOpen] = useState(false);
  const [userInfoOpen, setuserInfoopen] = useState(false);
  const navigate = useNavigate();
  const [studentData, setStudentData] = useState({});
  const [profile, setProfile] = useState("");
  const [mobile, SeToMobile] = useState(false);
  const [showMessagesPopup, setShowMessagesPopup] = useState(false);

  const [notisubject, setNotiSubject] = useState(null);
  const [notimessage, setNotiMessage] = useState(null);
  const [changeNotiId, setNotiId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [isEventActive, setIsEventActive] = useState(false);

  const [noti, setNoti] = useState([]);
  const [count, setcount] = useState(0);
  const dropdownRef = useRef(null);
  const dropdownResultRef = useRef(null);
  const dropdownDownloadRef = useRef(null);
  const handleModalClose = () => {
    setShowModal(false);
  };

  const { http } = Api();

  useEffect(() => {
    const resultdata = localStorage.getItem("student_details");
    if (resultdata) {
      const parseresultdata = JSON.parse(resultdata);
      setStudentData(parseresultdata[0]);
      localStorage.setItem("user", parseresultdata[0].studentname);
      localStorage.setItem("scheme_id", parseresultdata[0].scheme_id);
      setProfile(parseresultdata[0].studentphoto.original.base64_image);
    }
  }, []);

  // useEffect(() => {
  //   http
  //     .get(`getActiveEvents`, { params: { event_id: 27 } })
  //     .then((response) => {
  //       const supplyeventstatus = response.data[0].status;
  //       if (supplyeventstatus === "closed") {
  //         setIsEventActive(false);
  //       } else {
  //         setIsEventActive(true);
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error in get active events:", error);
  //       setIsEventActive(false);
  //     });
  // }, []);

  const handleViewModalOpen = (
    instaid,
    notisubject,
    notimessage,
    msgstatus
  ) => {
    setNotiSubject(notisubject);
    setNotiMessage(notimessage);
    setShowModal(true);

    const messagedata = async (instaid) => {
      const { http } = Api();

      await http
        .post(`/Admin/markAsRead`, {
          id: instaid,
        })
        .then((response) => {
          setNotiId(instaid);
          if (response.data) {
            console.log("Message marked as read");
          }
        })
        .catch((error) => {
          console.error("Error in marking as read");
        });
    };

    if (msgstatus == "sent") {
      messagedata(instaid);
    }
  };

  const isLinkActive = (path) => {
    return location.pathname === path;
  };

  const [condonationCount, setCondonationCount] = useState(0);
  const [eventStatus, setEventStatus] = useState(null);

  useEffect(() => {
    const { http } = Api();

    const fetchCondonationNotification = async () => {
      try {
        const response = await http.get(
          "/Student/studentCondonationNotification"
        );
        const { NotificationCount, event_status } = response.data;
        setCondonationCount(NotificationCount || 0);
        setEventStatus(event_status);
      } catch (error) {
        console.error("🔔 Error fetching condonation notification:", error);
      }
    };

    fetchCondonationNotification();

    const interval = setInterval(fetchCondonationNotification, 600000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    setIsDownloadsOpen(
      // location.pathname === '/studentexamregistration' ||
      location.pathname === "/paymentbills"
    );

    setIsResultsOpen(
      location.pathname === "/studentcoattainment" ||
      location.pathname === "/studentresult"
    );
  }, [location.pathname]);

  const activeStyle = {
    background: "linear-gradient(to left, #6f2443, #8a2f55)",
    borderRadius: "7px",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    margin: "10px 5px",
    width: "92%",
    transition: "all 0.3s ease",
    color: "white",
  };

  useEffect(() => {
    const handleResize = () => {
      setIsSidebarOpen(window.innerWidth > 767);
      SeToMobile(window.innerWidth < 500);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  /* const toggleDownloads = () => {
    setIsDownloadsOpen(!isDownloadsOpen);
  }; */
  const toggleDownloads = () => {
    setIsDownloadsOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If clicked outside the dropdown, close it
      if (
        dropdownDownloadRef.current &&
        !dropdownDownloadRef.current.contains(event.target)
      ) {
        setIsDownloadsOpen(false);
      }
    };

    if (isDownloadsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isDownloadsOpen]);

  const toggleResults = () => {
    setIsResultsOpen((prev) => !prev);
  };
  useEffect(() => {
    const handleClickOutside = (event) => {
      // If clicked outside the dropdown, close it
      if (
        dropdownResultRef.current &&
        !dropdownResultRef.current.contains(event.target)
      ) {
        setIsResultsOpen(false);
      }
    };

    if (isResultsOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isResultsOpen]);
  /* const toggleResults = () => {
    setIsResultsOpen(!isResultsOpen);
  }; */

  /* const toggleUserinfo = () => {
      setuserInfoopen(!userInfoOpen);
   }; */

  const toggleUserinfo = () => {
    setuserInfoopen((prev) => !prev);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setuserInfoopen(false);
      }
    };

    if (userInfoOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [userInfoOpen]);

  const logout = () => {
    http
      .get("logout")
      .then((response) => {
        if (response.data.status_code === "MSG6") {
          console.log("Token revoked successfully");
          sessionStorage.removeItem("message");
          localStorage.clear();

          navigate("/");
        }
      })
      .catch((error) => {
        sessionStorage.removeItem("message");
        localStorage.clear();
        window.location.reload();
      });
  };

  useEffect(() => {
    http
      .get(`/Admin/userSpecificNotificationCount`)
      .then((response) => {
        setcount(response.data.notification_count);
      })
      .catch((error) => {
        // console.log('Error fetching instruction or notification:', error);
      });

    http
      .get(`/Admin/getNotificationsAndMessages`)
      .then((response) => {
        if (response.status === 200) {
          setNoti((previous) => {
            const filteredNotifications = response.data.filter(
              (option) => option.msg_type === "notification"
            );
            return filteredNotifications;
          });
        } else {
          setNoti([]);
        }
      })
      .catch((error) => {
        // console.log('Error fetching instruction or notification:', error);
      });
  }, [changeNotiId]);

  //console.log("studentData=", studentData);

  return (
    <div id="page-top">
      <div id="wrapper" className={styles["d-flex"]}>
        <ul
          className={`${styles["navbar-nav"]} ${styles["bg-gradient-primary"]
            } ${styles.sidebar} ${styles["sidebar-dark"]} ${styles.accordion} ${isSidebarOpen ? "" : styles["toggled"]
            }`}
          id="accordionSidebar"
        >
          <a
            className={`${styles["sidebar-brand"]} ${styles["d-flex"]} ${styles["align-items-center"]} ${styles["justify-content-center"]}`}
          >
            <div className={`${styles["sidebar-brand-icon"]}`}>
              {mobile ? (
                <img
                  className="img-fluid for-light"
                  src={logo2}
                  alt="MGU Logo"
                  style={{ width: "60%" }}
                />
              ) : isSidebarOpen && !mobile ? (
                <img
                  className="img-fluid for-light"
                  src={logo}
                  alt="MGU Logo"
                />
              ) : (
                <img
                  className="img-fluid for-light"
                  src={logo2}
                  alt="MGU Logo"
                  style={{ width: "60%" }}
                />
              )}
            </div>
          </a>

          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentdashboard") ? styles.active : ""
              }`}
            style={isLinkActive("/studentdashboard") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/studentdashboard"
              style={{
                marginLeft: isLinkActive("/studentdashboard") ? "-4px" : "0",
              }}
            >
              <i
                className="fas fa-fw fa-tachometer-alt"
                style={{
                  color: isLinkActive("/studentdashboard") ? "white" : "",
                }}
              ></i>
              <span
                style={{
                  color: isLinkActive("/studentdashboard") ? "white" : "",
                }}
              >
                Dashboard
              </span>
            </Link>
          </li>

          <hr class={styles["sidebar-divider"]} />

          <div class={styles["sidebar-heading"]}>{/* Links */}</div>

          <li
            className={`${styles["nav-item"]} ${isLinkActive("/profile") ? styles.active : ""
              }`}
            style={isLinkActive("/profile") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/profile"
              style={{ marginLeft: isLinkActive("/profile") ? "-4px" : "0" }}
            >
              <i
                className="fas fa-fw fa-user"
                style={{ color: isLinkActive("/profile") ? "white" : "" }}
              ></i>
              <span style={{ color: isLinkActive("/profile") ? "white" : "" }}>
                Profile
              </span>
            </Link>
          </li>



          {/* Major Switching based on scheme_id Old code */}
          {/* {studentData.scheme_id && studentData.scheme_id === 1 && (studentData.currentsemester === 2 || studentData.currentsemester ===3) && (
            <li className={styles['nav-item']}>
              <a
                className={styles['nav-link']}
                href="https://cap.mgu.ac.in:8443/smartswitch/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: "0" }}
              >         
                
                <i className="fas fa-fw fa-retweet"></i>
                <span>Major Switching</span>
              </a>
            </li>
          )} */}

          {/* Major Switching based on scheme_id New code*/}

          {studentData.scheme_id &&
            studentData.scheme_id === 1 &&
            (studentData.currentsemester === 2 ||
              studentData.currentsemester === 3) ? (
            <li className={styles["nav-item"]}>
              <a
                className={styles["nav-link"]}
                href="https://cap.mgu.ac.in:8443/smartswitch_phase2/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ marginLeft: "0" }}
              >
                <i className="fas fa-fw fa-retweet lft-icn-cont-aln"></i>
                <span>Major Switching / College Transfer</span>
              </a>
            </li>
          ) : (
            studentData.scheme_id &&
            (studentData.scheme_id === 2 || studentData.scheme_id === 3) &&
            (studentData.currentsemester === 2 ||
              studentData.currentsemester === 3) && (
              <li className={styles["nav-item"]}>
                <a
                  className={styles["nav-link"]}
                  href="https://cap.mgu.ac.in:8443/smartswitch_phase2/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginLeft: "0" }}
                >
                  <i className="fas fa-fw fa-retweet"></i>
                  <span>College Transfer</span>
                </a>
              </li>
            )
          )}
          {/* Major Switching based on scheme_id End */}

          {/* This <li></li> hide and  Course Selection split to Bvoc and MGUUP course selction below */}

          {/* 
          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentcourseselection") ? styles.active : ""
              }`}
             style={isLinkActive("/studentcourseselection") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/studentcourseselection"
              style={{
                marginLeft: isLinkActive("/studentcourseselection")
                  ? "-4px"
                  : "0",
              }}
            >
              <i
                className="fas fa-fw fa-chart-area"
                style={{
                  color: isLinkActive("/studentcourseselection") ? "white" : "",
                }}
              ></i>
              <span
                style={{
                  color: isLinkActive("/studentcourseselection") ? "white" : "",
                }}
              >
                Course Selection
              </span>
            </Link>
          </li> */}

          {/* BVoc or MGUUGP Menu */}

          {studentData.scheme_id == 4 ? (
            <>
              {/* BVoc Menu */}

              <li
                className={`${styles["nav-item"]} ${isLinkActive("/studentbvoccourseselection")
                  ? styles.active
                  : ""
                  }`}
                style={
                  isLinkActive("/studentbvoccourseselection") ? activeStyle : {}
                }
              >
                <Link
                  className={styles["nav-link"]}
                  to="/studentbvoccourseselection"
                  style={{
                    marginLeft: isLinkActive("/studentbvoccourseselection")
                      ? "-4px"
                      : "0",
                  }}
                >
                  <i
                    className="fas fa-fw fa-chart-area"
                    style={{
                      color: isLinkActive("/studentbvoccourseselection")
                        ? "white"
                        : "",
                    }}
                  ></i>
                  <span
                    style={{
                      color: isLinkActive("/studentbvoccourseselection")
                        ? "white"
                        : "",
                    }}
                  >
                    B.Voc Course Selection
                  </span>
                </Link>
              </li>
              {/* BVoc Menu  End*/}
            </>
          ) : (
            <>
              {/* MGUUGP Menu*/}

              <li
                className={`${styles["nav-item"]} ${isLinkActive("/studentcourseselection") ? styles.active : ""
                  }`}
                style={
                  isLinkActive("/studentcourseselection") ? activeStyle : {}
                }
              >
                <Link
                  className={styles["nav-link"]}
                  to="/studentcourseselection"
                  style={{
                    marginLeft: isLinkActive("/studentcourseselection")
                      ? "-4px"
                      : "0",
                  }}
                >
                  <i
                    className="fas fa-fw fa-chart-area"
                    style={{
                      color: isLinkActive("/studentcourseselection")
                        ? "white"
                        : "",
                    }}
                  ></i>
                  <span
                    style={{
                      color: isLinkActive("/studentcourseselection")
                        ? "white"
                        : "",
                    }}
                  >
                    Course Selection
                  </span>
                </Link>
              </li>
              {/* MGUUGP Menu End*/}
            </>
          )}

          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentepapercopyview") ? styles.active : ""
              }`}
            style={isLinkActive("/studentepapercopyview") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/studentepapercopyview"
              style={{
                marginLeft: isLinkActive("/studentepapercopyview")
                  ? "-4px"
                  : "0",
              }}
            >
              <i
                className="fas fa-fw fa-file-pdf"
                style={{
                  color: isLinkActive("/studentepapercopyview") ? "white" : "",
                }}
              ></i>
              <span
                style={{
                  color: isLinkActive("/studentepapercopyview") ? "white" : "",
                }}
              >
                E-Copy /RV/ Scrutiny
              </span>
            </Link>
            {/* <Link className={`${styles['nav-link']} d-flex align-items-center`}
              to="/studentepapercopyview"
              style={{ marginLeft: isLinkActive('/studentepapercopyview') ? "-4px" : "0" }}>
              <i className="fas fa-fw fa-file-pdf me-2"
                style={{ color: isLinkActive('/studentepapercopyview') ? "white" : "" }}>
              </i>
              <span style={{ color: isLinkActive('/studentepapercopyview') ? "white" : "" }}>
                E-Copy/<br/>Revaluation/Scrutiny
              </span>
            </Link> */}
          </li>

          {/* <li className={`${styles['nav-item']} ${isLinkActive('/studentexamregistration') ? styles.active : ''}`}
            style={isLinkActive('/studentexamregistration') ? activeStyle : {}}>
            <Link className={styles['nav-link']} to="/studentexamregistration" style={{ marginLeft: isLinkActive('/studentexamregistration') ? "-4px" : "0" }}>
              <i className="fas fa-fw fa-download" style={{ color: isLinkActive('/studentexamregistration') ? "white" : "" }}></i>
              <span style={{ color: isLinkActive('/studentexamregistration') ? "white" : "" }}>Downloads</span>
            </Link>
          </li> */}

          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentexamregistration") ? styles.active : ""
              }`}
            style={isLinkActive("/studentexamregistration") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/studentexamregistration"
              style={{
                marginLeft: isLinkActive("/studentexamregistration")
                  ? "-4px"
                  : "0",
              }}
            >
              <i
                className="bi bi-file-earmark-text-fill"
                style={{
                  color: isLinkActive("/studentexamregistration")
                    ? "white"
                    : "",
                }}
              ></i>
              <span
                style={{
                  color: isLinkActive("/studentexamregistration")
                    ? "white"
                    : "",
                }}
              >
                Exam Registration
              </span>
            </Link>
          </li>

          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentsupplyorbetterment") ? styles.active : ""
              }`}
            style={
              isLinkActive("/studentsupplyorbetterment") ? activeStyle : {}
            }
          >
            <Link
              className={`${styles["nav-link"]}`}
              to="/studentsupplyorbetterment"
              style={{
                marginLeft: isLinkActive("/studentsupplyorbetterment")
                  ? "-4px"
                  : "0",
                position: "relative",
              }}
            >
              <i
                className="fa-solid fa-book"
                style={{
                  color: isLinkActive("/studentsupplyorbetterment")
                    ? "white"
                    : "",
                }}
              ></i>

              <span
                style={{
                  color: isLinkActive("/studentsupplyorbetterment")
                    ? "white"
                    : "",
                }}
              >
                Supply / Betterment
              </span>

              {/* Badge - Expanded Sidebar */}
              {isEventActive && isSidebarOpen && (
                <span
                  className="badge rounded-pill position-absolute d-none d-md-inline-flex"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  1
                </span>
              )}

              {/* Badge - Collapsed Sidebar */}
              {isEventActive && !isSidebarOpen && (
                <span
                  className="badge rounded-pill position-absolute d-none d-md-inline-flex"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "4px",
                    right: "4px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  1
                </span>
              )}

              {/* Badge - Mobile */}
              {isEventActive && (
                <span
                  className="badge rounded-pill position-absolute d-inline-flex d-md-none"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "4px",
                    right: "4px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  1
                </span>
              )}
            </Link>
          </li>
          <li
            className={`${styles["nav-item"]} ${isLinkActive("/condonation") ? styles.active : ""
              }`}
            style={isLinkActive("/condonation") ? activeStyle : {}}
          >
            <Link
              className={`${styles["nav-link"]}`}
              to="/condonation"
              style={{
                marginLeft: isLinkActive("/condonation") ? "-4px" : "0",
                position: "relative",
              }}
            >
              <i
                className="fa-solid fa-money-check"
                style={{
                  color: isLinkActive("/condonation") ? "white" : "",
                }}
              ></i>

              <span
                style={{
                  color: isLinkActive("/condonation") ? "white" : "",
                }}
              >
                Condonation
              </span>

              {/* Notification Count Badge - Expanded Sidebar */}
              {eventStatus === "active" &&
                condonationCount > 0 &&
                isSidebarOpen && (
                  <span
                    className="badge rounded-pill position-absolute d-none d-md-inline-flex"
                    style={{
                      fontSize: "0.7rem",
                      fontWeight: "600",
                      minWidth: "20px",
                      height: "20px",
                      padding: "0 6px",
                      lineHeight: "20px",
                      alignItems: "center",
                      justifyContent: "center",
                      top: "50%",
                      right: "8px",
                      transform: "translateY(-50%)",
                      backgroundColor: "#dc3545",
                      color: "white",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    {condonationCount}
                  </span>
                )}

              {/* Notification Count Badge - Collapsed Sidebar (Desktop) & Mobile */}
              {eventStatus === "active" &&
                condonationCount > 0 &&
                !isSidebarOpen && (
                  <span
                    className="badge rounded-pill position-absolute d-none d-md-inline-flex"
                    style={{
                      fontSize: "0.7rem",
                      fontWeight: "600",
                      minWidth: "20px",
                      height: "20px",
                      padding: "0 6px",
                      lineHeight: "20px",
                      alignItems: "center",
                      justifyContent: "center",
                      top: "4px",
                      right: "4px",
                      backgroundColor: "#dc3545",
                      color: "white",
                      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                    }}
                  >
                    {condonationCount}
                  </span>
                )}

              {/* Notification Count Badge - Mobile Only */}
              {eventStatus === "active" && condonationCount > 0 && (
                <span
                  className="badge rounded-pill position-absolute d-inline-flex d-md-none"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "4px",
                    right: "4px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  {condonationCount}
                </span>
              )}

              {/* Notification Dot */}
              {/* {eventStatus === "active" && condonationCount === 0 && (
                <span
                  className="position-absolute border border-light rounded-circle"
                  title="New Condonation Event Active"
                  style={{
                    width: "10px",
                    height: "10px",
                    padding: 0,
                    top: "8px",
                    right: "8px",
                    backgroundColor: isLinkActive("/condonation")
                      ? "white"
                      : "#dc3545",
                    boxShadow: isLinkActive("/condonation")
                      ? "0 2px 4px rgba(255,255,255,0.4)"
                      : "0 2px 4px rgba(220,53,69,0.4)",
                  }}
                ></span>
              )} */}
            </Link>
          </li>
          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentreadmission") ? styles.active : ""
              }`}
            style={isLinkActive("/studentreadmission") ? activeStyle : {}}
          >
            <Link
              className={`${styles["nav-link"]}`}
              to="/studentreadmission"
              style={{
                marginLeft: isLinkActive("/studentreadmission") ? "-4px" : "0",
                position: "relative",
              }}
            >
              <i
                className="fa-solid fa-user-plus"
                style={{
                  color: isLinkActive("/studentreadmission") ? "white" : "",
                }}
              ></i>

              <span
                style={{
                  color: isLinkActive("/studentreadmission") ? "white" : "",
                }}
              >
                Readmission
              </span>

              {isEventActive && isSidebarOpen && (
                <span
                  className="badge rounded-pill position-absolute d-none d-md-inline-flex"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "50%",
                    right: "8px",
                    transform: "translateY(-50%)",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  1
                </span>
              )}

              {isEventActive && !isSidebarOpen && (
                <span
                  className="badge rounded-pill position-absolute d-none d-md-inline-flex"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "4px",
                    right: "4px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  1
                </span>
              )}

              {isEventActive && (
                <span
                  className="badge rounded-pill position-absolute d-inline-flex d-md-none"
                  style={{
                    fontSize: "0.7rem",
                    fontWeight: "600",
                    minWidth: "20px",
                    height: "20px",
                    padding: "0 6px",
                    lineHeight: "20px",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "4px",
                    right: "4px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
                  }}
                >
                  1
                </span>
              )}
            </Link>
          </li>
          {/* internship  */}
          <li
            className={`${styles["nav-item"]} ${isLinkActive("/studentinternship") ? styles.active : ""
              }`}
            style={isLinkActive("/studentinternship") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/studentinternship"
              style={{ marginLeft: isLinkActive("/studentinternship") ? "-4px" : "0" }}
            >
              <i
                className="fas fa-fw fa-user"
                style={{ color: isLinkActive("/studentinternship") ? "white" : "" }}
              ></i>
              <span style={{ color: isLinkActive("/studentinternship") ? "white" : "" }}>
                Internship
              </span>
            </Link>
          </li>

          <li
            className={`${styles["nav-item"]} ${isLinkActive("/externalcredit") ? styles.active : ""
              }`}
            style={isLinkActive("/externalcredit") ? activeStyle : {}}
          >
            <Link
              className={styles["nav-link"]}
              to="/externalcredit"
              style={{
                marginLeft: isLinkActive("/externalcredit") ? "-4px" : "0",
              }}
            >
              <i
                className="fas fa-fw fa-chalkboard-user"
                style={{ color: isLinkActive("/externalcredit") ? "white" : "" }}
              ></i>
              <span
                style={{
                  color: isLinkActive("/externalcredit") ? "white" : "",
                  verticalAlign: 'middle',
                }}
              >
                External Credit Application
              </span>
            </Link>
          </li>



          <li className={styles["nav-item"]} ref={dropdownResultRef}>
            <a
              className={`${styles["nav-link"]} ${isResultsOpen ? "" : styles["collapsed"]
                }`}
              onClick={toggleResults}
              style={{ cursor: "pointer" }}
              data-toggle="collapse"
              data-target="#collapseThree"
              aria-controls="collapseThree"
            >
              <i className="fas fa-fw fa-graduation-cap"></i>
              <span>Result</span>
            </a>
            <div
              id="collapseThree"
              className={`${styles.collapse} ${isResultsOpen ? styles.show : ""
                }`}
              aria-labelledby="headingThree"
              data-parent="#accordionSidebar"
            >
              <div
                className={`${styles["bg-white"]} ${styles["py-2"]} ${styles["collapse-inner"]} ${styles["rounded"]}`}
              >
                <Link
                  className={`${styles["collapse-item"]} ${isLinkActive("/studentresult") ? styles.active : ""
                    }`}
                  to="/studentresult"
                  style={isLinkActive("/studentresult") ? activeStyle : {}}
                  onClick={() => setIsResultsOpen(false)}
                >
                  Exam Result
                </Link>
                <Link
                  className={`${styles["collapse-item"]} ${isLinkActive("/studentcoattainment") ? styles.active : ""
                    }`}
                  to="/studentcoattainment"
                  style={
                    isLinkActive("/studentcoattainment") ? activeStyle : {}
                  }
                  onClick={() => setIsResultsOpen(false)}
                >
                  CO Attainment
                </Link>
              </div>
            </div>
          </li>

          <li className={styles["nav-item"]} ref={dropdownDownloadRef}>
            <a
              className={`${styles["nav-link"]} ${isDownloadsOpen ? "" : styles["collapsed"]
                }`}
              onClick={toggleDownloads}
              style={{ cursor: "pointer" }}
              data-toggle="collapse"
              data-target="#collapseTwo"
              aria-controls="collapseTwo"
            >
              <i className="fas fa-fw fa-download"></i>
              <span>Downloads</span>
            </a>
            <div
              id="collapseTwo"
              className={`${styles.collapse} ${isDownloadsOpen ? styles.show : ""
                }`}
              aria-labelledby="headingTwo"
              data-parent="#accordionSidebar"
            >
              <div
                className={`${styles["bg-white"]} ${styles["py-2"]} ${styles["collapse-inner"]} ${styles["rounded"]}`}
              >
                {/* <h6 className={styles['collapse-header']}>Links</h6> */}
                {/*<Link className={`${styles['collapse-item']} ${isLinkActive('/studentexamregistration') ? styles.active : ''}`}
                  to="/studentexamregistration"
                  style={isLinkActive('/studentexamregistration') ? activeStyle : {}}>Exam Registration
                </Link> */}

                <Link
                  className={`${styles["collapse-item"]} ${isLinkActive("/paymentbills") ? styles.active : ""
                    }`}
                  to="/paymentbills"
                  style={isLinkActive("/paymentbills") ? activeStyle : {}}
                >
                  Transactions
                </Link>
              </div>
            </div>
          </li>

          <hr
            class={`${styles["sidebar-divider"]}  ${styles["d-none"]} ${styles["d-none"]} ${styles["d-md-block"]}  `}
          ></hr>

          <div className={`${styles["sidebar-button-container"]}`}>
            <div
              className={`${styles["text-center"]} ${styles["d-none"]} ${styles["d-md-inline"]
                } ${styles["sidebar-dark"]} ${isSidebarOpen ? styles["sidebarTo"] : ""
                } `}
            >
              <button
                className={` ${styles["border-0"]}  ${styles["transparent-button1"]
                  } ${isSidebarOpen
                    ? styles["sidebarToggled"]
                    : styles["sidebarToggled1"]
                  } `}
                onClick={toggleSidebar}
              ></button>
            </div>
          </div>
        </ul>

        <div
          id="content-wrapper"
          className={`${styles["d-flex"]} ${styles["flex-column"]} ${styles["content-wrapper"]}`}
          style={{ width: "100%" }}
        >
          <nav
            className={`${styles["navbar"]} ${styles["navbar-expand"]} ${styles["navbar-light"]} ${styles["bg-white"]} ${styles.topbar} ${styles["mb-4"]} ${styles["static-top"]} ${styles.shadow}`}
          >
            <button
              className={`${styles["btn"]} ${styles["btn-link"]} ${styles["d-md-none"]
                } ${styles["rounded-circle"]} ${styles["mr-3"]}  ${isSidebarOpen ? styles["sidebar-toggle-top"] : ""
                }`}
              onClick={toggleSidebar}
            >
              <i className="fa fa-bars"></i>
            </button>
            <ul className={`${styles["navbar-nav"]} ${styles["ml-auto"]}`}>
              <div
                className={`${styles["topbar-divider"]} ${styles["d-none"]} ${styles["d-sm-block"]}`}
              ></div>
              <li
                ref={dropdownRef} // Attach ref to the dropdown container
                className={`${styles["nav-item"]} ${styles["dropdown"]} ${styles["no-arrow"]
                  }  ${userInfoOpen ? styles.show : ""}`}
              >
                <a
                  className={`${styles["nav-link"]} ${styles["dropdown-toggle"]}`}
                  onClick={toggleUserinfo}
                  id="userDropdown"
                  role="button"
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded={userInfoOpen ? "true" : "false"}
                >
                  <span
                    className={`${styles["mr-2"]} ${styles["d-none"]} ${styles["d-lg-inline"]} ${styles["text-gray-600"]} ${styles["small"]}`}
                  >
                    {studentData.studentname !== ""
                      ? studentData.studentname
                      : "Student Name"}
                  </span>
                  <img
                    className={`${styles["img-profile"]} ${styles["rounded-circle"]}`}
                    src={profile}
                  />
                </a>
                <div
                  className={`${styles["dropdown-menu"]} ${styles["dropdown-menu-right"]
                    } ${styles["shadow"]} ${styles["animated--grow-in"]} ${userInfoOpen ? styles.show : ""
                    }`}
                  aria-labelledby="userDropdown"
                >
                  <Link className={`${styles["dropdown-item"]}`} to="/profile">
                    <i
                      className={`fas fa-user fa-sm fa-fw  ${styles["mr-2"]} ${styles["text-gray-clr-400"]}`}
                    ></i>
                    Profile
                  </Link>
                  <Link
                    className={`${styles["dropdown-item"]}`}
                    to="/studentchangepassword"
                  >
                    <i
                      className={`fas fa-lock fa-sm fa-fw  ${styles["mr-2"]} ${styles["text-gray-clr-400"]}`}
                    ></i>
                    Change Password
                  </Link>
                  <Link
                    className={`${styles["dropdown-item"]}`}
                    to="/studenthelp"
                  >
                    <i
                      className={`fas fa-question-circle fa-sm fa-fw ${styles["mr-2"]} ${styles["text-gray-clr-400"]}`}
                    ></i>
                    Help
                  </Link>
                  <div
                    className={`${styles["dropdown-item"]}`}
                    onClick={logout}
                    style={{ cursor: "pointer" }}
                  >
                    <i
                      className={`fas fa-sign-out-alt fa-sm fa-fw ${styles["fa-fw"]} ${styles["mr-2"]} ${styles["text-gray-clr-400"]}`}
                    ></i>
                    Logout
                  </div>
                </div>
              </li>

              <div
                className="text-dark text-decoration-none   mt-4"
                onMouseEnter={() => setShowMessagesPopup(true)}
                onMouseLeave={() => setShowMessagesPopup(false)}
              >
                <MessageIcon
                  className="username-icn icn-fn-sz clg-icn-clr2"
                  aria-hidden="true"
                />
                {count > 0 && (
                  <span
                    className="message-count"
                    style={{ top: "20px", right: "15px" }}
                  >
                    {count}
                  </span>
                )}

                {showMessagesPopup && (
                  <div
                    className="messages-popup mr-10 pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht2 scrollable-bar-wt"
                    style={{ top: "55px", right: "22px", width: "334px" }}
                  >
                    <div className="title-message1">Notifications</div>
                    <ul style={{ padding: "15px" }}>
                      {Array.isArray(noti) && noti.length > 0 ? (
                        noti.map((item, index) => {
                          return (
                            <li
                              key={index}
                              className="b-l-primary border-4 newstyle"
                            >
                              <p
                                onClick={() =>
                                  handleViewModalOpen(
                                    item.id,
                                    item.subject,
                                    item.message,
                                    item.status
                                  )
                                }
                              >
                                {item.subject.length > 20
                                  ? item.subject.substring(0, 30) + "..."
                                  : item.subject}
                                {item.status === "sent" && (
                                  <span className="badge badge-light-secondary ml-2">
                                    New
                                  </span>
                                )}
                              </p>
                            </li>
                          );
                        })
                      ) : (
                        <li className="b-l-primary border-4 newstyle">
                          <p>You don't have any Notifications</p>
                        </li>
                      )}
                    </ul>
                    <div
                      className="card-footer text-center"
                      style={{ borderRadius: "5px" }}
                    ></div>
                  </div>
                )}
              </div>
            </ul>
          </nav>
          <div id="content">
            {/* //top navbar content end */}
            <div
              className="col py-3 content-scroll45  "
              style={{ marginRight: "1%", marginLeft: "1%" }}
            >
              <div className="card-body pt-0 activity-scroll-container activity-scroll-bar-container clg-card-ht2 scrollable-bar-wt">
                <ImpersonationBanner />
                {children}
              </div>
            </div>
          </div>

          <footer class={`${styles["sticky-footer"]} ${styles["bg-white"]}`}>
            <div class={`${styles["container"]} ${styles["my-auto"]}`}>
              <div
                class={`${styles["copyright"]} ${styles["text-center"]} ${styles["my-auto"]} st-footer-ft`}
              >
                <span>
                  © Mahatma Gandhi University, Priyadarsini Hills, Kottayam,
                  Kerala, India - 686560
                </span>
              </div>
            </div>
          </footer>
        </div>
      </div>
      <div
        style={{ backgroundColor: "#7a787878" }}
        class={`modal fade bd-example-modal-lg ${showModal ? "show d-block" : ""
          }`}
        tabindex="-1"
        role="dialog"
        aria-labelledby="myExtraLargeModal"
        aria-hidden="true"
      >
        <div
          class="modal-dialog modal-lg"
          style={{ textAlign: "-webkit-center" }}
        >
          <div class="modal-content">
            <div class="modal-header">
              <h4 class="modal-title mobile1" id="myExtraLargeModal">
                {notisubject}
              </h4>
              <button
                class="btn-close py-0"
                type="button"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => handleModalClose()}
              ></button>
            </div>
            <div class="modal-body dark-modal">
              <div class="large-modal-header">
                <i data-feather="chevrons-right"></i>
              </div>
              <p
                class="modal-padding-space mb-0 mobilep"
                dangerouslySetInnerHTML={{ __html: notimessage }}
              ></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
